export class ContractConstants {
  public static download_auth_profiles = ["developer", "director"];
  public static download_auth_skills = ["regional_manager", "manager"];
  public static additional_visit_contract_statuses = ["signed", "in_signature", "signed_incident"];
  public static editable_contract_statuses = ["created", "in_signature", "visit_incident", "signed_incident"];
  public static updatable_contract_statuses = ["in_signature", "signed", "visit_incident", "signed_incident"];
  public static generating_contract_statuses = ["requested", "with_incidents"];

  public static skip_visit_message =
    "Al omitir la visita, el contrato quedará como <br/>aprobado y podrás solicitar el desembolso.";
  public static success_update_message =
    "El proveedor recibirá la información <br/> para visitar al cliente y firmar su contrato";

  public static visit_responsible_options = [
    { value: "client", label: "Cliente" },
    { value: "nexu", label: "NEXU" },
    { value: "provider", label: "Proveedor" },
    { value: "agency", label: "Agencia" },
    { value: "specialist", label: "Especialista" },
  ];

  public static contract_data_dot_status = {
    created: { label: "Generado", style: "bg-slate-grey" },
    in_signature: { label: "Agendado", style: "bg-warm-blue" },
    signed: { label: "Visita por evaluar / Aprobado", style: "bg-secondary" },
    deprecated: { label: "Cancelado", style: "bg-lightish-red" },
    visit_incident: { label: "Visita con incidencia", style: "bg-yellow-corn" },
    signed_incident: { label: "Firmado con incidencia", style: "bg-warning" },
    disbursed: { label: "Desembolsado", style: "bg-secondary" },
  };

  public static visit_reason_options = [
    "No coincide documentación",
    "Cliente no se encontraba en domicilio",
    "Cliente se presentó en otro domicilio",
    "Firma no coincide",
    "Cliente no permitió toma de fotografías",
    "Cliente no estuvo de acuerdo con proceso / montos de contrato",
    "Cliente no contaba con conocimiento sobre contrato previo a visita",
    "Otro",
  ];

  public static updatable_contract_stages = [
    { value: "in_signature", name: "Agendado" },
    { value: "signed", name: "Visita por evaluar / Aprobado" },
    { value: "visit_incident", name: "Visita con incidencia" },
    { value: "signed_incident", name: "Firmado con incidencia" },
  ];
}
